export default {
    methods: {
        isValidJson(str) {
            try {
                JSON.parse(str)
            } catch (e) {
                return false
            }
            return true
        }
    }
}
